
import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Main from "@/views/Main.vue";
import ManageSurveys from "@/views/ManageSurveys.vue";
import RegisterSurveyors from "@/views/RegisterSurveyors.vue";
import RegisterAdmins from "@/views/RegisterAdmins.vue";
import Configuration from "@/views/Configuration.vue";
import Utilities from "@/views/Utilities.vue";
import CreateBroadcast from "@/views/CreateBroadcast.vue";
import Broadcast from "@/views/Broadcast.vue";
import ForgotPassword from "@/views/ForgotPassword.vue";
import Resource from "@/views/resource.vue";

Vue.use(VueRouter)


const routes = [

  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/ForgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/Main/:id',
    name: 'Main',
    component: Main,
    props: true,

    children: [
      {
        path: "ManageSurveys",
        component: ManageSurveys
      },
      {
        path: "RegisterSurveyors",
        component: RegisterSurveyors
      },
      {
        path: "RegisterAdmins",
        component: RegisterAdmins
      },
      {
        path: "Configuration",
        component: Configuration
      },
      {
        path: "Utilities",
        component: Utilities
      },
      {
        path: "CreateBroadcast",
        component: CreateBroadcast
      }, {
        path: "Broadcast",
        component: Broadcast
      },
      {
        path: "Resource",
        component: Resource
      }
    ]
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
